import React, { useState, useRef, useEffect } from "react";
import {faArrowUp, faSort, faSortDown, faSortUp} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import "./../utils/Style/common.scss";
// import EmptyTransactionsMessage from "./EmptyTransactionsMessage";

const TableSelect = (props) => {
    const componentRef = useRef(null);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    // const handleRowClick = (row) => {
    //     if(props.list === "cashing"){
    //         if (row.original.OrderID && row.original.OrderID!=="-") {
    //             props.setActiveRowIndex(row.index);
    //             props.setAmountDetails(row.original.Transaction || row.original.OrderID)
    //             props.setVisible(true)
    //         }
    //     }else {

    //         if (props.statementofaccounts && row.original?.IsPayrollReference){
    //             if (props.currencyId === 1) {
    //                 props.setPayrollRef("-1")
    //             }else {
    //                 props.setPayrollRef("-2")
    //             }
    //         }else{
    //             if (props?.setPayrollRef)
    //                 props.setPayrollRef(null)
    //         }
    //         if ((row.original.Transaction && row.original.Transaction!=="-") || (row.original.OrderID && row.original.OrderID!=="-")){
    //             props.setActiveRowIndex(row.index);
    //             props.setAmountDetails(row.original.Transaction || row.original.OrderID)
    //             props.setVisible(true)
    //         }
    //     }
    //     console.log('Row clicked:', row.original);
    // };

    const handleRowClick = (row) => {
        if (!props.blockedEmployees[row.original.EmployeeID]) {
            props.setActiveRowIndex(row.index);
            props.handleOpenModal(row);
        }
    };

    const handleRowOverviewClick = (row) => {
        props.setActiveRowIndex(row.index); 
        props.handleOpenModal(row.original); 
    };
    
    useEffect(() => {
        window.addEventListener("resize", () => setScreenWidth(window.innerWidth));
        return () => window.removeEventListener("resize", () => setScreenWidth(window.innerWidth));
    }, []);

    return (
        <>
            {screenWidth < 768 ? (
                // <div id="table-container-mobile" ref={componentRef}>
                //     {props.headerGroups.map((headerGroup) => (
                //         <div {...headerGroup.getHeaderGroupProps()} className="theader">
                //             {headerGroup.headers.map((column) => (
                //                 <div {...column.getHeaderProps()} className="eachone">
                //                     {column.render("BillsHeader")}
                //                 </div>
                //             ))}
                //         </div>
                //     ))}
                //     {props.page.map((row) => {
                //         props.prepareRow(row);
                //         const isActive = props.activeRowIndex === row.index;
                //
                //         return (
                //             <div {...row.getRowProps()} className={` tbody ${isActive ? "tractive" : ""}`}>
                //                 {isActive ? <button className="showmoreactive" onClick={() => { props.setActiveRowIndex(-1) }}><FontAwesomeIcon icon={faArrowUp} /></button>
                //                     : <></>}
                //
                //                 {row.cells.map((cell) => (
                //                     <div {...cell.getCellProps()} className={`eachone ${isActive ? "tdactive" : ""}`}>
                //                         {cell.render("Cell")}
                //                     </div>
                //                 ))}
                //             </div>
                //         );
                //     })}
                // </div>
                <></>
            ) : (
                <div id="table-container" className={props.activeRowIndex === -1 ? "" : " usdTableSelect"} ref={componentRef}>
                    <table {...props.getTableProps()} className="AllTable">
                        <thead>
                            {props.headerGroups.map((headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map((column) => (
                                        // <th {...column.getHeaderProps()}>
                                        //     {column.render("BillsHeader")}
                                        // </th>
                                        <th {...column.getHeaderProps((props.sort && (column.id === "Status" || column.id === "Amount" || column.Header === "Recipient" || column.Header === "Sender" || column.Header === "Amount Held" || column.Header === "Pickup Location")) ? column.getSortByToggleProps() : {})}>
                                            {(props.sort && (column.id === "Status" || column.id === "Amount" || column.Header === "Recipient" || column.Header === "Sender" || column.Header === "Amount Held" || column.Header === "Pickup Location")) ? (
                                                <div className="sort-header">
                                                    <span>
                                                        {column.render("Header")}
                                                    </span>
                                                    <span className="sort-icon">
                                                        {column.isSorted ? (column.isSortedDesc ?
                                                                <FontAwesomeIcon icon={faSortDown}/> :
                                                                <FontAwesomeIcon icon={faSortUp}/>) :
                                                            <FontAwesomeIcon icon={faSort}/>}
                                                    </span>
                                                </div>
                                            ) : (
                                                <>
                                                    {column.render("Header")}
                                                </>
                                            )}
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        {

                        }
                        <tbody {...props.getTableBodyProps()}>
                            {props.page.map((row) => {
                                props.prepareRow(row);
                                const isActive = props.activeRowIndex === row.index;
                                const IsDisabled = row.original.Status === "INACTIVE" || row.original.IsStatusChanged;
                                const isBlocked = row.original.isBlocked;
                                return (
                                    <tr
                                        {...row.getRowProps()}
                                        className={`${isBlocked ? "blocked-row" : ""} ${IsDisabled? "trdisabled" : isActive ? "tractive" : ""}`}
                                    >
                                        {row.cells.map((cell) => (
                                            <td
                                            {...cell.getCellProps()}
                                            className={isActive ? "tdactive" : ""}
                                            onClick={() => {
                                                if (props.isOverview) {
                                                    handleRowOverviewClick(row);  
                                                } else {
                                                    if (!isBlocked) {
                                                        handleRowClick(row);  
                                                    }
                                                }
                                            }}    
                                        >
                                            {cell.render("Cell")}
                                        </td>
                                        ))}
                                    </tr>
                                );
                            })}

                        </tbody>
                    </table>
                    {/* <>
                        {
                            props.totalNbPage === 0 &&
                            <EmptyTransactionsMessage/>
                        }
                    </> */}
                </div>
            )}
        </>
    );
}

export default TableSelect;
